<div class="privacy-container" [class.dark-theme]="isDarkMode" [class.light-theme]="!isDarkMode">
  <div class="privacy-content">
    <!-- Header con título y selector de idioma -->
    <div class="privacy-header">
      <h1 class="privacy-title">{{ content.title }}</h1>
      <button class="language-toggle" (click)="toggleLanguage()" [attr.aria-label]="currentLanguage === 'es' ? 'Switch to English' : 'Cambiar a Español'">
        <span *ngIf="currentLanguage === 'es'" class="language-toggle-content"> 
          <svg class="language-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="2" y1="12" x2="22" y2="12"></line>
            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
          </svg>
          <span class="language-text">EN</span>
        </span>
        <span *ngIf="currentLanguage === 'en'" class="language-toggle-content">
          <svg class="language-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="2" y1="12" x2="22" y2="12"></line>
            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
          </svg>
          <span class="language-text">ES</span>
        </span>
      </button>
    </div>

    <!-- Introducción -->
    <p class="privacy-intro">{{ content.intro }}</p>

    <!-- Secciones -->
    <div class="privacy-sections">
      <!-- Información recopilada -->
      <section class="privacy-section">
        <h2 class="section-title">{{ content.sections.information.title }}</h2>
        <p class="section-content">{{ content.sections.information.content }}</p>
      </section>

      <!-- Uso de la información -->
      <section class="privacy-section">
        <h2 class="section-title">{{ content.sections.use.title }}</h2>
        <p class="section-content">{{ content.sections.use.content }}</p>
      </section>

      <!-- Contenido del usuario -->
      <section class="privacy-section">
        <h2 class="section-title">{{ content.sections.content.title }}</h2>
        <p class="section-content">{{ content.sections.content.content }}</p>
      </section>

      <!-- Seguridad -->
      <section class="privacy-section">
        <h2 class="section-title">{{ content.sections.security.title }}</h2>
        <p class="section-content">{{ content.sections.security.content }}</p>
      </section>

      <!-- Servicios de terceros -->
      <section class="privacy-section">
        <h2 class="section-title">{{ content.sections.thirdParty.title }}</h2>
        <p class="section-content">{{ content.sections.thirdParty.content }}</p>
      </section>

      <!-- Cambios a esta política -->
      <section class="privacy-section">
        <h2 class="section-title">{{ content.sections.changes.title }}</h2>
        <p class="section-content">{{ content.sections.changes.content }}</p>
      </section>

      <!-- Contacto -->
      <section class="privacy-section">
        <h2 class="section-title">{{ content.sections.contact.title }}</h2>
        <p class="section-content">{{ content.sections.contact.content }}</p>
      </section>
    </div>
  </div>
  
</div>
<footer>
    <div class="footer-container">
      <p data-i18n="footerCopyright">&copy; 2025 Punto de Fuga. Todos los derechos reservados.</p>
      <div class="footer-links">
        <a routerLink="/privacy" data-i18n="footerPrivacy">Política de Privacidad</a>
        <a routerLink="/support" data-i18n="footerContact">Soporte</a>
      </div>
    </div>
  </footer>
